/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Image_Inspector_Copy_Css_VarsInputs */

const en_image_inspector_copy_css_vars = /** @type {(inputs: Image_Inspector_Copy_Css_VarsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CSS vars`)
};

const ar_image_inspector_copy_css_vars = /** @type {(inputs: Image_Inspector_Copy_Css_VarsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`متغيرات CSS`)
};

const bn_image_inspector_copy_css_vars = /** @type {(inputs: Image_Inspector_Copy_Css_VarsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CSS ভেরিয়েবল`)
};

const de_image_inspector_copy_css_vars = /** @type {(inputs: Image_Inspector_Copy_Css_VarsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CSS-Variablen`)
};

const es_image_inspector_copy_css_vars = /** @type {(inputs: Image_Inspector_Copy_Css_VarsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Variables CSS`)
};

const fr_image_inspector_copy_css_vars = /** @type {(inputs: Image_Inspector_Copy_Css_VarsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Variables CSS`)
};

const pt_image_inspector_copy_css_vars = /** @type {(inputs: Image_Inspector_Copy_Css_VarsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Variáveis CSS`)
};

const zh_image_inspector_copy_css_vars = /** @type {(inputs: Image_Inspector_Copy_Css_VarsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CSS 变量`)
};

const tr_image_inspector_copy_css_vars = /** @type {(inputs: Image_Inspector_Copy_Css_VarsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CSS değişkenleri`)
};

const ru_image_inspector_copy_css_vars = /** @type {(inputs: Image_Inspector_Copy_Css_VarsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Переменные CSS`)
};

const pl_image_inspector_copy_css_vars = /** @type {(inputs: Image_Inspector_Copy_Css_VarsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zmienne CSS`)
};

/**
* | output |
* | --- |
* | "CSS vars" |
*
* @param {Image_Inspector_Copy_Css_VarsInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const image_inspector_copy_css_vars = /** @type {((inputs?: Image_Inspector_Copy_Css_VarsInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Inspector_Copy_Css_VarsInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_image_inspector_copy_css_vars(inputs)
	if (locale === "bn") return bn_image_inspector_copy_css_vars(inputs)
	if (locale === "de") return de_image_inspector_copy_css_vars(inputs)
	if (locale === "es") return es_image_inspector_copy_css_vars(inputs)
	if (locale === "fr") return fr_image_inspector_copy_css_vars(inputs)
	if (locale === "pt") return pt_image_inspector_copy_css_vars(inputs)
	if (locale === "zh") return zh_image_inspector_copy_css_vars(inputs)
	if (locale === "tr") return tr_image_inspector_copy_css_vars(inputs)
	if (locale === "ru") return ru_image_inspector_copy_css_vars(inputs)
	if (locale === "pl") return pl_image_inspector_copy_css_vars(inputs)
	return en_image_inspector_copy_css_vars(inputs)
});